import { render, staticRenderFns } from "./InstantLoginView.vue?vue&type=template&id=86232da6&scoped=true&"
import script from "./InstantLoginView.vue?vue&type=script&lang=ts&"
export * from "./InstantLoginView.vue?vue&type=script&lang=ts&"
import style0 from "./InstantLoginView.vue?vue&type=style&index=0&id=86232da6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86232da6",
  null
  
)

export default component.exports